import { Component } from '@angular/core';

@Component({
  selector: 'app-debug-face',
  templateUrl: './debug-face.component.html',
  standalone: false
})
export class DebugFaceComponent {

  onFileReady(video_: Blob): void {
  }

}
